/* @flow */

import * as React from 'react';
import { range } from 'lodash/fp';
import t from 'app/utils/translate';
import LineUpButton from './LineUpButton';

type Props = {
  abbr: string,
  filled?: boolean,
  firstChallengeId?: string,
  games?: Array<*>,
  id: string,
  isRacing?: boolean,
  name: string,
  onGameSelect?: (id: string) => void,
  onPositionSelect?: (id: string) => void,
  remaining?: number,
  renderEntity: () => React.Node,
  selections?: Array<*>
};

class LineUpSection extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    filled: false,
    firstChallengeId: undefined,
    games: [],
    isRacing: false,
    onGameSelect: undefined,
    onPositionSelect: undefined,
    selections: [],
    remaining: 0
  };

  handleSelect = () => {
    const { games, id, isRacing, onGameSelect, onPositionSelect } = this.props;

    if (isRacing) {
      const game = games.find(g => !g.filled);
      if (game) {
        onGameSelect(game.id);
      }
    } else {
      onPositionSelect(id);
    }
  };

  render() {
    const {
      abbr,
      filled,
      firstChallengeId,
      id,
      isRacing,
      name,
      onPositionSelect,
      remaining,
      renderEntity,
      selections
    } = this.props;

    return (
      <div>
        {selections.map((entity, i) =>
          renderEntity(
            {
              ...entity,
              isRacing,
              positionAbbr: abbr,
              positionId: id,
              firstChallengeId
            },
            i
          )
        )}
        {!filled && onPositionSelect && (
          <React.Fragment>
            {range(0, remaining).map(i => (
              <LineUpButton key={i} onSelect={() => this.handleSelect()}>
                {t('Add')} {isRacing ? `Leg` : name}
              </LineUpButton>
            ))}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default LineUpSection;
